<template>
  <div class="d-flex justify-content-center">
    
    <template v-if="is_on_error">
      <b-alert show variant="danger">Les services sont actuellements indisponibles</b-alert>
    </template>

    <template v-else-if="is_loading">
      <b-spinner style="width: 10rem; height: 10rem;" variant="primary"></b-spinner>
    </template>


    <template v-else-if="is_invalid">
      <b-alert show variant="danger">L'invitation n'est pas valide</b-alert>
    </template>

    <template v-else-if="now_timestamp > end_timestamp">
      <b-alert show variant="info">La visioconférence est finie</b-alert>
    </template>


    <template v-else-if="not_yet">
      <b-alert show variant="warning">La visioconférence n'a pas encore commencée, début le {{$moment(start_timestamp, "X").format("dddd DD MMMM YYYY à HH:mm")}}</b-alert>
    </template>


    <template v-else>
      <b-form class="mt-5">
        <b-form-input v-model="name" placeholder="NOM prénom"></b-form-input>
        <b-form-input v-model="email" placeholder="email"></b-form-input>
        <b-button class="mt-5" @click="join" variant="success" block>Rejoindre</b-button>
      </b-form>
    </template>




  </div>

</template>

<script>
    export default {
        data() {
            return {
                is_loading: true,
                is_invalid: false,
                is_on_error: false,
                is_outdated: false,
                name: "",
                email: "",
                start_timestamp: 0,
                end_timestamp: 0,
                now_timestamp: 0,
                interval: null,
            }
        },

        methods: {
            async join() {
                try {
                    const response = await this.axios.post(`${window.location.origin}/api/visio/context_to_jwt`, {
                        jwt: this.$route.params.jwt,
                        name: this.name,
                        email: this.email,
                    })
                    window.location.href = response.data.route
                    console.log(response)


                }
                catch(error) {
                    console.log(error)
                }
            }
        },


        computed: {
            not_yet() {
                return this.now_timestamp < this.start_timestamp
                // return false
            },

            start_date() {
                return this.$moment(this.start_timestamp, "X")
            },
            end_date() {
                return this.$moment(this.end_timestamp, "X")
            },
        },

        beforeDestroy() {
            clearInterval(this.interval);
        },

        async created() {
            this.interval = setInterval(() => this.now_timestamp = this.$moment().unix(), 1000);

            try {
                const response = await this.axios.get(`${window.location.origin}/api/visio/context_from_jwt`, {
                    params: {
                        jwt: this.$route.params.jwt
                    }
                })
                this.is_loading = false

                this.name = response.data.name
                this.email = response.data.email
                this.start_timestamp = response.data.start_timestamp
                this.end_timestamp = response.data.end_timestamp

            }
            catch(error) {
                if (error.response && error.response.status === 400) {
                  this.is_invalid = true
                }
                else {
                    this.is_on_error = true
                    console.error(error)

                }
            }
        }
    }
</script>
